import { evaluateFlags, flagsClient, getDefinitions } from '@tkww/tkww-feature-flags-sdk-nextjs';
import { FEATURE_FLAG_OVERRIDE_COOKIE, UNLEASH_SESSION_COOKIE } from 'constants/FeatureFlags';

export const evaluateFeatureFlag = async (flagName, ctx) => {
  const sessionId =
    ctx.req.cookies[UNLEASH_SESSION_COOKIE] || `${Math.floor(Math.random() * 1_000_000_000)}`;
  ctx.res.setHeader('set-cookie', `${UNLEASH_SESSION_COOKIE}=${sessionId}; path=/;`);

  const definitions = await getDefinitions({
    fetchOptions: {
      next: { revalidate: 15 }, // Cache layer like Unleash Proxy!
    },
  });
  const context = {
    sessionId, // needed for stickiness
    // userId: "123" // etc
  };

  const { toggles } = await evaluateFlags(definitions, context);
  const featureFlagOverrides = ctx.req.cookies[FEATURE_FLAG_OVERRIDE_COOKIE];
  const flags = flagsClient(toggles, featureFlagOverrides, ctx);
  return flags.isEnabled(flagName);
};
